import { render, staticRenderFns } from "./AddButton.vue?vue&type=template&id=b6e35466&scoped=true"
import script from "./AddButton.vue?vue&type=script&lang=js"
export * from "./AddButton.vue?vue&type=script&lang=js"
import style0 from "./AddButton.vue?vue&type=style&index=0&id=b6e35466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e35466",
  null
  
)

export default component.exports